import { getPermissionById } from '@/utils';
import { useMemo } from 'react';

interface ProductItem {
  label: string;
  value: string;
}

interface UsePermissionProductsProps {
  resourceList: any[];
  permissionMap: Array<{
    permissionKey: string;
    product: ProductItem;
  }>;
}

export const usePermissionProducts = ({
  resourceList,
  permissionMap
}: UsePermissionProductsProps): ProductItem[] => {
  return useMemo(() => {
    if (!resourceList?.length) return [];
    
    return permissionMap
      .map(({ permissionKey, product }) => 
        getPermissionById(permissionKey) ? product : null
      )
      .filter(Boolean) as ProductItem[];
  }, [resourceList, permissionMap]);
};
